import { EntityChangeFeed, FrankServiceEntityPersistence } from "@hds/entity-lib";
import { DeltaServerChangeEventsPipelineManager } from "./DeltaServer.change-events-pipeline-manager.mjs";

class DeltaServerChangeFeed extends EntityChangeFeed {
    #_baseUri;
    #_entityName;
    #_customHeaderFn;
    constructor(EntityKlass, deltaServerClient, baseUri, entityName, customHeaderFn, projection = undefined) {
        super(EntityKlass, new DeltaServerChangeEventsPipelineManager(deltaServerClient, entityName, projection), projection);
        this.#_baseUri = baseUri;
        this.#_entityName = entityName;
        this.#_customHeaderFn = customHeaderFn;
    }
    /*****************************************************/
    /* START ABSTRACT METHOD IMPLEMENTATIONS */
    /*****************************************************/
    async _createEntityPersistence() {
        const ep = new FrankServiceEntityPersistence(this.#_baseUri, this.#_entityName, this.#_customHeaderFn);
        return ep;
    }
    /*****************************************************/
    /* END ABSTRACT METHOD IMPLEMENTATIONS */
    /* START CHANGE FEED METHOD OVERRIDES */
    /*****************************************************/
    async _shutdown() {
        await super._shutdown();
    }
    /*****************************************************/
    /* END CHANGE FEED METHOD OVERRIDES */
    /*****************************************************/
}

export { DeltaServerChangeFeed };
export default DeltaServerChangeFeed;